export const initWxCode = () => {
  const maxWaitTime = 10000; // 最大等待时间10秒
  const checkInterval = 100; // 检查间隔100毫秒
  let waitTime = 0;

  const checkAndInit = () => {
    const wxLogin = window.WxLogin;
    if (wxLogin) {
      // SDK已加载，执行初始化
      setTimeout(() => {
        new wxLogin({
          self_redirect: false,
          id: "code-node",
          appid: "wx8c9a93acb12e2b2d",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(
            `https://www.jiqizhixin.com/auth/wechat/callback?origin_url=${location.href}`
          ),
          state: Math.ceil(Math.random() * 1000),
          // 为1 href 会失效
          stylelite: 1,
          style: "black",
          href:
            "data:text/css;base64,LndlYl9xcmNvZGVfaW1nIHsgd2lkdGg6IDIwMHB4OyBoZWlnaHQ6IDIwMHB4IH0KLndlYl9xcmNvZGVfaW1nX3dycCB7IGJvcmRlcjogMXB4IHNvbGlkICNlMmUyZTIgfQo=",
        });
      });
    } else if (waitTime < maxWaitTime) {
      // SDK未加载，继续等待
      waitTime += checkInterval;
      setTimeout(checkAndInit, checkInterval);
    } else {
      // 超时，打印错误信息
      console.error("微信登录SDK加载超时，请检查网络连接或脚本路径");
    }
  };

  checkAndInit();
};
